import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { setupLoadingInterceptors } from "./axiosConfig";

const LoadingContext = createContext({ isLoading: false });

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [requestCount, setRequestCount] = useState(0);

  const showLoader = useCallback(() => {
    setRequestCount((c) => c + 1);
  }, []);

  const hideLoader = useCallback(() => {
    setRequestCount((c) => Math.max(0, c - 1));
  }, []);

  // Register axios interceptors once on mount
  useEffect(() => {
    setupLoadingInterceptors(showLoader, hideLoader);
  }, [showLoader, hideLoader]);

  return (
    <LoadingContext.Provider value={{ isLoading: requestCount > 0, showLoader, hideLoader }}>
      {children}
    </LoadingContext.Provider>
  );
};
